import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { baseUrl, URLs } from 'src/constants/urls';
import Accordion from '../accordion/Accordion';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import Search from '../search/search';
import Title from '../title/Title';
import accordionData from './accordionData';
import './NewHelpSupportItems.css'

export interface INewItemsProps {
    history: any;
}

class NewHelpSupportItems extends React.Component<INewItemsProps> {
    public state: any;
    constructor(props: any) {
        super(props);
    }
    public render() {

        const breadcrumbItems = [{ caption: "What's new", url: `${URLs.whatsNew}` }]
        return (
            <Col xs="12">
                <Breadcrumbs items={breadcrumbItems} redirect={this.redirect} />
                <Row>
        <Col xs={{ size: 10, offset: 1 }} className="pt-2">
                <Search />
                <Title title={"What's new in Gem Connect?"} />
                <Row className="tile-container">
            <Col xs="12">
              <div className="topic-content"  >
                  <p>Keep up to date with changes and improvements we’ve made to Gem Connect.</p>
                  <hr className="newhelphr"/>
                  <p className="newhelppara"><strong>We’re improving our CHAPS payments functionality</strong></p>
                  <p>To help you when processing CHAPS payments, if you’re submitting a CHAPS and the payment amount is suitable for the Faster Payment Service, we’ll tell you.  This change will be seen in both our CHAPS payment screen and when using our CHAPS file upload functionality.</p>
                  <p className="newhelppara"><strong>You asked us for transaction timestamps</strong></p>
                  <p>We’ve listened to your feedback, and we’ve made new fields available in the following screens and reports:</p>
                  <p>
                  <ul>
                  <li>Transaction History</li>
                  <li>Transaction Detail Report</li>
                  <li>Balance and Transaction Report</li>
                  </ul>
                  </p>
                  <p>You’ll see the new attributes when viewing the above and when exporting.</p>
                <div>
                    <div className="newhelpcont" >
                    < h3 >Archive</h3>
                    </div>
                    <div>
                        <Row>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>April 2025</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData6}/>
                        </Col>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>March 2025</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData5}/>
                        </Col>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>December 2024</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData4}/>
                        </Col>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>June 2024</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData3}/>
                        </Col>
                        </Row>
                    </div>
                </div>
                </div>
                
            </Col>
          </Row>
                </Col>
                </Row>
            </Col>
        );
    }
    private redirect = (url = baseUrl) => {
        this.props.history.push(url)
    }
};

export default NewHelpSupportItems;




// WEBPACK FOOTER //
// ./src/components/newHelpSupportItems/NewHelpSupportItems.tsx